import React, { useState, useEffect, lazy, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AOS from "aos";
import SpinMasterPrivacyPolicy from "./Components/SpinMasterPrivacyPolicy";
import SpinMasterTermsConditions from "./Components/SpinMasterTermsConditions";
import CompassPrivacyPolicy from "./Components/CompassPrivacyPolicy/index";
import CompassTermsAndConditions from "./Components/CompassTermsAndConditions/index";
import FamilyIslandPrivacyPolicy from "./Components/FamilyIslandPrivacyPolicy";
import FamilyIslandTermsAndConditions from "./Components/FamilyIslandTermsAndConditions";
import PdFlexPrivacyPolicy from "./Components/PdFlexPrivacyPolicy";
import PdFlexTermsConditions from "./Components/PdFlexTermsConditions";
import MonopolyTermsAndConditions from "./Components/MonopolyTermsAndConditions";
import MonopolyPrivacyPolicy from "./Components/MonopolyPrivacyPolicy";
import "aos/dist/aos.css";
import "./App.css";
import CrazyFoxPrivacyPolicy from "./Components/CrazyFoxPrivacyPolicy";
import CrazyFoxTermsAndConditions from "./Components/CrazyFoxTermsAndConditions";
import MessagesPrivacyPolicy from "./Components/MessagesPrivacyPolicy";
import MessagesTermsAndConditions from "./Components/MessagesTermsAndConditions";
import ContactsPrivacyPolicy from "./Components/ContactsPrivacyPolicy";
import ContactsTermsAndConditions from "./Components/ContactsTermsAndConditions";
const Navbar = lazy(() => import("./Components/Navbar"))
const Home = lazy(() => import('./Components/Home/Index'))
const About = lazy(() => import('./Components/About/Index'))
const Services = lazy(() => import('./Components/Services/Index'))
const Portfolio = lazy(() => import('./Components/Portfolio/Index'))
const Contact = lazy(() => import('./Components/ContactUs/Index'))
const ErrorPage = lazy(() => import('./Components/Error/ErrorPage'))

const App = () => {
  const [scrollPos, setScrollPos] = useState(0);
  const { pathname } = useLocation();
  const showNavbarAndFooter = !pathname.startsWith("/spin-master") && !pathname.startsWith("/compass")
    && !pathname.startsWith("/family-island") && !pathname.startsWith("/pdflex") && !pathname.startsWith("/monopoly")
    && !pathname.startsWith("/crazy-fox") && !pathname.startsWith("/messages") && !pathname.startsWith("/contact");
  const [homeEmail, setHomeEmail] = useState("")
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: false,
      mirror: true,
    });
    AOS.refresh();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  // window.addEventListener("contextmenu", (e) => e.preventDefault());
  return (
    <div>
      {showNavbarAndFooter && (
        <Suspense><Navbar scrollPos={scrollPos} setScrollPos={setScrollPos} /></Suspense>
      )}
      <Routes>
        <Route path="/" element={<Suspense><Home setHomeEmail={setHomeEmail} /></Suspense>} />
        {/* <Route path="/blog" element={<Blog/>} /> */}
        <Route path="/about" element={<Suspense><About /></Suspense>} />
        <Route path="/services" element={<Suspense><Services /></Suspense>} />
        <Route path="/portfolio" element={<Suspense><Portfolio /></Suspense>} />
        <Route path="/contact" element={<Suspense><Contact homeEmail={homeEmail} setHomeEmail={setHomeEmail} /></Suspense>} />
        {/* <Route path="/blog-details/:id" element={<BlogDetails/>} /> */}
        <Route
          path="/spin-master/privacy-policy"
          element={<SpinMasterPrivacyPolicy />}
        />
        <Route
          path="/spin-master/terms-and-conditions"
          element={<SpinMasterTermsConditions />}
        />
        <Route
          path="/compass/privacy-policy"
          element={<CompassPrivacyPolicy />}
        />
        <Route
          path="/compass/terms-and-conditions"
          element={<CompassTermsAndConditions />}
        />
        <Route
          path="/family-island/privacy-policy"
          element={<FamilyIslandPrivacyPolicy />}
        />
        <Route
          path="/family-island/terms-and-conditions"
          element={<FamilyIslandTermsAndConditions />}
        />
        <Route
          path="/pdflex/privacy-policy"
          element={<PdFlexPrivacyPolicy />}
        />
        <Route
          path="/pdflex/terms-and-conditions"
          element={<PdFlexTermsConditions />}
        />
        <Route
          path="/monopoly/privacy-policy"
          element={<MonopolyPrivacyPolicy />}
        />
        <Route
          path="/monopoly/terms-and-conditions"
          element={<MonopolyTermsAndConditions />}
        />
        <Route
          path="/crazy-fox/privacy-policy"
          element={<CrazyFoxPrivacyPolicy />}
        />
        <Route
          path="/crazy-fox/terms-and-conditions"
          element={<CrazyFoxTermsAndConditions />}
        />
        <Route
          path="/messages/privacy-policy"
          element={<MessagesPrivacyPolicy />}
        />
        <Route
          path="/messages/terms-and-conditions"
          element={<MessagesTermsAndConditions />}
        />
        <Route
          path="/contact/privacy-policy"
          element={<ContactsPrivacyPolicy />}
        />
        <Route
          path="/contact/terms-and-conditions"
          element={<ContactsTermsAndConditions />}
        />
        <Route path="*" element={<Suspense><ErrorPage /></Suspense>} />
      </Routes>
    </div>
  );
};

export default App;
